import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

/**
 * Sends a GA4 pageview event whenever the React Router location changes.
 * Safe to call when GA is not initialized (react-ga4 is a no-op in that case),
 * so this runs in all environments but only emits data in production.
 */
const usePageTracking = (): void => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }, [location]);
};

export default usePageTracking;
